import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RocketIcon } from 'lucide-react';
export function OfferBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleClick = () => {
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-142">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 28
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-brand-border shadow-[0_-8px_30px_rgba(10,31,68,0.1)]" data-id="element-143">
          <div className="max-w-3xl mx-auto px-4 py-3 sm:py-4 flex items-center justify-between gap-3" data-id="element-144">
            <div className="flex flex-col leading-tight" data-id="element-145">
              <span className="text-[10px] sm:text-xs font-black uppercase tracking-widest text-brand-muted" data-id="element-146">
                Komplett-System
              </span>
              <span className="text-2xl sm:text-3xl font-black text-brand-navy" data-id="element-147">
                47.90 CHF
              </span>
            </div>
            <button onClick={handleClick} className="flex-1 max-w-[60%] sm:max-w-none inline-flex items-center justify-center gap-2 bg-brand-navy text-white font-black uppercase text-sm sm:text-base px-4 sm:px-6 py-3 sm:py-4 rounded-xl shadow-lg hover:scale-[1.02] transition-transform" data-id="element-148">
              <RocketIcon className="w-5 h-5 shrink-0" data-id="element-149" />
              <span className="truncate" data-id="element-150">JA! ICH WILL MEIN SYSTEM JETZT</span>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}